module.exports = __webpack_public_path__ + "img/mit.29e35cde.png";